import { Box, Grid } from '@material-ui/core';
import { formatDateTimeReadable, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { CreditCardConditionsSummary } from '@/components/modules/CreditCard/Detail/Overview/components/CreditCardConditionsSummary';
import { Workflow } from '@/components/modules/CreditCard/Detail/Overview/components/Workflow/Workflow';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
// import { Participants } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/Participants/Participants';
import { OverviewDetailRow } from '@/components/shared/components/OverviewDetailRow';
import { Text } from '@/components/shared/components/Text';
import { CreditCard, CreditCardWorkflow } from '@/config/types';
import { useUser } from '@/hooks/useUser';

interface CreditCardHeaderDetailsProps {
  creditCard: CreditCard;
  workflow: CreditCardWorkflow;
}

export const CreditCardHeaderDetails = ({ creditCard, workflow }: CreditCardHeaderDetailsProps) => {
  const { userEntity } = useUser();

  if (!userEntity) {
    return null;
  }

  return (
    <>
      <Box mb={6} display={'flex'} flexDirection={'column'}>
        {userEntity.isRoleAdminOrSuperAdmin() && (
          <OverviewDetailRow
            field={
              <>
                <Text tId={'CREDIT_CARD_ID'} />:
              </>
            }
            value={creditCard.id}
            copyButton
          />
        )}
        <OverviewDetailRow
          field={
            <>
              <Text tId={'IBERIA_CARD_ID'} />:
            </>
          }
          value={creditCard.creditCardRequestId ?? '-'}
          copyButton={!!creditCard.creditCardRequestId}
        />
        <OverviewDetailRow
          field={<Text tId={'CREATED_AT'} />}
          value={formatDateTimeReadable(new Date(creditCard.createdAt))}
        />
      </Box>
      <Grid container spacing={6}>
        <Grid item xs={12} lg={6}>
          <CreditCardConditionsSummary creditCard={creditCard} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <CustomPaper fill="paper" style={{ padding: 16 }}>
            <Workflow status={creditCard.status} workflow={workflow} type={PaymentMethodType.CREDIT_CARD} />
          </CustomPaper>
        </Grid>
      </Grid>
    </>
  );
};
